import React from "react";
import {d4UpdateBid} from "../commons/api/D4Api";
import EiaButton from "../components/EiaButton";
import {findByKeyValue} from "../commons/Utils/ArrayUtils";
import TradeDialog from "../components/dialogs/TradeDialog";
import {BASE_BIDS_HEADERS} from "../commons/TableHeaders";
import ShowDetailsButton from "../components/ShowDetailsButton";
import EiaAuctionsWithButtons from "../components/EiaAuctionsWithButtons";
import Utils from "../commons/Utils/Utils";
import {REJECT_REASONS_BIDDER_TO_SELLER} from "../commons/enums/BackendEnums";
import WithdrawBidDialog from "../components/dialogs/WithdrawBidDialog";
import * as ApiUtils from "../commons/api/ApiUtils";

const tableInitialState = {
    sorting: {
        sortModel: [{ field: 'creationDate', sort: 'desc' }],
    },
}

const MyBidsPage = function (props) {
    const {bidsState} = props;

    const [isLoading, setIsLoading]  = React.useState(false);
    const [alert, setAlert] = React.useState(null)

    const tableData = bidsState.bids;

    const [selectedAuctionId, setSelectedAuctionId] = React.useState([])
    const [openTradeDialog, setOpenTradeDialog] = React.useState(false);
    const [openAuctionSpecificDialog, setOpenAuctionSpecificDialog] = React.useState(false);
    const [openWithdrawBidDialog, setOpenWithdrawBidDialog] = React.useState(false);

    const selectedAuction = selectedAuctionId.length === 0 ? null : findByKeyValue(tableData, "id", selectedAuctionId);

    const reloadMyBids = function(keepAlert) {
        if(keepAlert) {
            bidsState.reload(setIsLoading, Utils.doNothing);
        } else {
            bidsState.reload(setIsLoading, setAlert);
        }
    }

    React.useEffect(() => {
        reloadMyBids();
    }, []);

    const withdraw = function(updateBidReasonEnum) {
        setIsLoading(true);

        const request = ApiUtils.getGameRequest(selectedAuction);
        request.auctionId = selectedAuction.id;
        request.status = "WITHDRAWN";
        request.reasonEnum = updateBidReasonEnum;

        d4UpdateBid(request, function (response) {
            setAlert(["success", ("Successfully withdrawn bid")]);
            setIsLoading(false);
            reloadMyBids(true);
        }, function (error) {
            setAlert(["error", error.message]);
            setIsLoading(false);
            reloadMyBids(true);
        })
    }

    const loadingOrNoSelectedAuction = isLoading || selectedAuctionId.length === 0 || selectedAuction === undefined || selectedAuction === null;

    const generalButtons = [
        <EiaButton key={"reloadButton"} isFullWidth onClick={reloadMyBids} disabled={isLoading} tooltip={"Reload all your bids"} >Reload</EiaButton>
    ]

    const auctionSpecificButtons = [
        <ShowDetailsButton key={"detailsButton"} isFullWidth disabled={loadingOrNoSelectedAuction} title={"Details"} details={selectedAuction}
                           additionalOnClose={() => setOpenAuctionSpecificDialog(false)} />,
        <EiaButton key={"withdrawButton"} isFullWidth colorTheme={"error"} onClick={() => {
            setOpenAuctionSpecificDialog(false);
            setOpenWithdrawBidDialog(true);
        }} disabled={loadingOrNoSelectedAuction} tooltip={"Withdraw your bid"}>Withdraw</EiaButton>,
        <EiaButton key={"tradeButton"} isFullWidth colorTheme={"success"} onClick={() => {
            setOpenAuctionSpecificDialog(false);
            setOpenTradeDialog(true);
        }} disabled={loadingOrNoSelectedAuction || selectedAuction.myBidStatus !== "ACCEPTED"} tooltip={"Trade your bid with bid status ACCEPTED"} >Trade ...</EiaButton>
    ]

    return (
        <div>
            <TradeDialog open={openTradeDialog} onCancel={() => setOpenTradeDialog(false)}
                         bidsState={bidsState}
                         auction={selectedAuction ? selectedAuction : null}
            />
            <WithdrawBidDialog open={openWithdrawBidDialog}
                             onClose={() => setOpenWithdrawBidDialog(false)}
                             withdrawBid={withdraw}
                             reasonMap={REJECT_REASONS_BIDDER_TO_SELLER}
            />
            <EiaAuctionsWithButtons
                alert={alert}
                isLoading={isLoading}
                tableData={tableData}
                tableHeaders={BASE_BIDS_HEADERS}
                tableInitialState={tableInitialState}
                generalButtons={generalButtons}
                auctionSpecificButtons={auctionSpecificButtons}
                selectedAuctionId={selectedAuctionId}
                selectedAuction={selectedAuction}
                setSelectedAuctionId={setSelectedAuctionId}
                openAuctionSpecificDialog={openAuctionSpecificDialog}
                setOpenAuctionSpecificDialog={setOpenAuctionSpecificDialog}
                setOpenTradeDialog={setOpenTradeDialog}
                isViewFromBidder={true}
            />
        </div>
    )
}
export default MyBidsPage;